import React, { Component } from "react";
import {
  NewButtonLink,
  SecondaryEditButtonLink,
} from "../common/customButtonLinks";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import formService from "../services/formService";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import Placeholder from "../common/placeholder";
import { toast } from "react-toastify";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import auth from "../services/authService";
import formatBr from "../helpers/formatDate";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

const FORM_STATUS_ENUM = {
  1: "Aprovado",
  2: "Rejeitado",
  3: "Pendente Coordenador",
  5: "Pendente Administrador",

};

class InscricoesBolsista extends Component {
  //SearchBar = Search.SearchBar;

  state = {
    forms: [],
    ready: false,
    removeModal: false,
    formToBeRemoved: {},
  };

  selectOptions = {
    "Pendente Coordenador": "Pendente Coordenador",
    "Pendente FAEPI": "Pendente FAEPI",
    Concluído: "Concluído",
  };

  columns = [
    {
      dataField: "key",
      text: "key",
      hidden: true,
    },
    {
      dataField: "coordenador.name",
      text: "Coordenador",
      style: { width: "14%" },
    },
    {
      dataField: "project",
      text: "Nome do Projeto",
      style: { width: "23%" },
    },
    {
      dataField: "coordenador.email",
      text: "Email Coordenador",
      style: { width: "24%" },
    },
    {
      dataField: "status",
      text: "Status",
      style: { width: "12%" },
    },
    {
      dataField: "createdAt",
      text: "Envio",
      headerClasses: "text-nowrap",
      formatter: formatBr,
      style: { width: "13%" },
    },
    {
      dataField: "functions",
      text: "Ação",
      isDummyField: true,
      style: { width: "13%" },
      formatter: (cell, row) => {
        const { id, status } = row;

        return (
          <SecondaryEditButtonLink
            className="text-white mt-1"
            text="Editar"
            color="secondary"
            to={`./${id}`}
            disabled={status !== FORM_STATUS_ENUM[2]}
          />
        );
      },
    },
  ];

  async componentDidMount() {


    let { data: forms } = await formService.getBolsistaForms();

    forms = forms.map((m) => ({
      ...m,
      status: FORM_STATUS_ENUM[m.status],
    }));

    this.setState({ forms, ready: true });

    console.log("InscricoesBolsistas - didMount", {forms})

  }

  handleClickEdit = ({ formId }) => {
    console.log("handle Edit", `/gerenciamento/formularios/${formId}`)
    this.props.history.push(`/gerenciamento/formularios/${formId}`);
  };

  render() {
    const { forms, ready } = this.state;
    console.log("InscricoesBolsistas - render", {forms});
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <Placeholder ready={ready}>

                <CardHeader className="bg-light">
                  <i className="fa fa-align-justify" /> Formulários
                </CardHeader>

                <CardBody>
                  <ToolkitProvider
                    keyField="id"
                    data={forms}
                    columns={this.columns}                    
                    search
                  >
                    {(props) => (
                      <div>
                        <Row style={{ marginBottom: "24px" }}>
                          <Col md={3}>
                            <NewButtonLink
                              text="Nova Inscrição"
                              className="text-white"
                              to="/gerenciamento/formularios/novo"
                              block
                            />
                          </Col>
                        </Row>
                        {forms.length > 0 ? (
                          <BootstrapTable
                            {...props.baseProps}
                            bootstrap4
                            bordered={false}
                            hover
                            classes="table-responsive"
                            filter={filterFactory()}
                            filterPosition="inline"
                            rowClasses="animated fadeIn"
                            noDataIndication="Nenhum Formulário"
                          />
                        ) : (
                          "Nenhum formulário de inscrição cadastrado"
                        )}
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Placeholder>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default InscricoesBolsista;
